import {Injectable} from '@angular/core'
import {BehaviorSubject} from 'rxjs'
import {LocalStorageService} from './local-storage.service'

@Injectable({
  providedIn: 'root',
})
export class ContextMenuService {
  private useCustomContextMenuKey = 'use-custom-context-menu'
  private contextMenuEnabledSubject: BehaviorSubject<boolean>

  constructor(private store: LocalStorageService) {
    this.initializeContextMenuSetting()
    this.contextMenuEnabledSubject = new BehaviorSubject<boolean>(
      this.checkContextMenuStatus(),
    )
  }

  private initializeContextMenuSetting() {
    if (this.store.getItem(this.useCustomContextMenuKey) === null) {
      // If the key does not exist, create it and set to true (enabled) - first run
      this.store.setItem(this.useCustomContextMenuKey, 'true')
    }
  }

  private checkContextMenuStatus(): boolean {
    const value = this.store.getItem(this.useCustomContextMenuKey)
    return value === 'true' // Enabled if the value is 'true'
  }

  getContextMenuEnabled(): BehaviorSubject<boolean> {
    return this.contextMenuEnabledSubject
  }

  updateContextMenuStatus(enabled: boolean): void {
    this.store.setItem(this.useCustomContextMenuKey, String(enabled))
    this.contextMenuEnabledSubject.next(enabled)
  }

  isCustomContextMenuEnabled(): boolean {
    return this.contextMenuEnabledSubject.getValue()
  }
}
